import {useNavigate} from 'react-router-dom';
import {FooterItemEvent} from '../../../utilities/helper/googleEvent/googleEvent';
import {useAuth} from '../../../context/authContext';
import IconSwitcher from './iconSwitcher';
import TitleSwitcher from './titleSwitcher';
import {googleAnalyticsInstance} from '../../../utilities/helper/googleAnalitics';

type TFooterItemType = {
  title: string;
  icon?: string;
  router: string;
  isMain?: boolean;
  isActive?: boolean;
};

const FooterItem = ({
  title,
  icon,
  router,
  isMain,
  isActive = false,
}: TFooterItemType) => {
  const navigate = useNavigate();
  const {supplierProfile} = useAuth();
  const handleRoute = () => {
    if (isMain && supplierProfile?.store?.store_status === 'accepted') {
      navigate('/shop/home');
    } else if (isMain && supplierProfile?.lab?.lab_status === 'accepted') {
      navigate('/lab/home');
    } else {
      navigate(router);
    }
  };

  return (
    <>
      <div
        className="d-flex flex-column justify-content-end align-items-center h-100 pb-2"
        onClick={() => {
          googleAnalyticsInstance.eventGoogleAnalytics(FooterItemEvent(router));
          handleRoute();
        }}
      >
        <IconSwitcher isMain={isMain} isActive={isActive} icon={icon} />
        <TitleSwitcher isMain={isMain} isActive={isActive} title={title} />
      </div>
    </>
  );
};

export default FooterItem;
